/** Stored file references on historical QuantisAI messages remain readable, and open for their sender. */
import { useState } from 'react';
import { FileText, ImageIcon } from '@/shared/ui/icons';
import { formatAttachmentSize, openSIAttachment, type SIAttachment } from './siAttachments';

export function SIMessageAttachments({ attachments, scope }: { attachments?: SIAttachment[]; scope?: { workspaceId: string; conversationId: string } }) {
  const [error, setError] = useState<string | null>(null);
  if (!attachments?.length) return null;
  const open = (attachment: SIAttachment) => {
    if (!scope) return;
    setError(null);
    openSIAttachment(attachment, scope).catch((cause: unknown) => setError(cause instanceof Error ? cause.message : 'The file could not be opened. Please retry.'));
  };
  return <>
    <ul aria-label="Attached files" className="mt-1.5 flex flex-wrap gap-1.5">
      {attachments.map(attachment => {
        const Icon = attachment.mimeType === 'application/pdf' ? FileText : ImageIcon;
        return <li key={attachment.id} className="flex min-w-0 max-w-full items-center gap-1.5 rounded-full border border-border px-2 py-1 text-xs">
          <Icon className="size-3.5 shrink-0" aria-hidden />
          {scope
            ? <button type="button" aria-label={`Open ${attachment.name}`} onClick={() => open(attachment)} title={attachment.name}
                className="min-w-0 truncate rounded-sm hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">{attachment.name}</button>
            : <span className="min-w-0 truncate" title={attachment.name}>{attachment.name}</span>}
          <span className="shrink-0 text-muted-foreground">{formatAttachmentSize(attachment.size)}</span>
        </li>;
      })}
    </ul>
    {error && <p role="alert" className="mt-1 text-xs text-destructive">{error}</p>}
  </>;
}
